import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import i18next from "i18next";


export default function HorizontalStepper({
  steps,
  activeStepNumber,
  screenWidth,
  onStepClick,
}) {
  const isArabic = i18next.language === 'ar';
  return (
    screenWidth > 450 && (
      <Box sx={{ width: "100%" }}>
        <Stepper
          orientation={"horizontal"}
          activeStep={activeStepNumber}
          alternativeLabel
          sx={{
            color: "#3173B1",
            cursor: "pointer",
            display:"flex",
            flexDirection:isArabic?'row-reverse':'row',
            // direction:  "ltr" , // U se parent's direction (rtl or ltr)
            width:"100%",
          }}
        >
          {steps.map((label, index) => (
            <Step key={label} onClick={() => onStepClick(index)}>
              <StepLabel
                sx={{
                  "& .MuiStepLabel-label": {
                    fontSize:
                      screenWidth > 2000
                        ? "24px"
                        : screenWidth > 1000
                          ? "18px"
                          : screenWidth > 500
                            ? "14px"
                            : screenWidth > 400
                              ? "11.5px"
                              : "9px", // Adjust font size here
                  },
                }}
              >
                {i18next.t(label)}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
    )
  );
}
